import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { PolicyPipesModule } from '@amfam/policy/pipes';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { ClaimListComponent } from './claim-list';
import { ClaimRiskComponent } from './claim-risk';

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    DsRouterLinkModule,
    ImpersonationModule,
    UiKitModule,
    PipesModule,
    SharedServicesModule,
    PolicyPipesModule
  ],
  declarations: [ClaimListComponent, ClaimRiskComponent],
  exports: [ClaimListComponent, ClaimRiskComponent]
})
export class ClaimSharedClaimListModule {}
